import { countLabel } from '@/utils/plural'
import { useAdminTripItineraryImports } from '@hooks/useAdminTripItineraryImports'
import React from 'react'
import { formatDateTime } from '../adminFormat'
import { Card, CardTitle, RelatedList, RelatedMeta, RelatedRow } from '../adminDetail.styles'
import { EmptyNoteInline } from '@components/EmptyState'
import { ErrorNote } from '@components/Notice'
import { StatusPill } from '../Imports/ImportsPage.styles'
import { importPath, sourceSummary, statusLabel, statusTone } from '../Imports/importView'
import { ImportRowLabel } from './TripImportsCard.styles'

/**
 * The trip's itinerary imports on the admin trip detail, newest first, each linking
 * to the import's detail. Loads on its own so a slow or failed read never holds up
 * the rest of the trip.
 */
const TripImportsCard: React.FC<{ tripId: number }> = ({ tripId }) => {
	const { data, isLoading, isError } = useAdminTripItineraryImports(tripId)

	return (
		<Card>
			<CardTitle>Itinerary imports{data ? ` (${data.imports.length})` : ''}</CardTitle>
			{isLoading ? (
				<EmptyNoteInline>Loading imports…</EmptyNoteInline>
			) : isError || !data ? (
				<ErrorNote>Could not load this trip's imports.</ErrorNote>
			) : data.imports.length === 0 ? (
				<EmptyNoteInline>No itinerary imports on this trip.</EmptyNoteInline>
			) : (
				<RelatedList>
					{data.imports.map(row => (
						<RelatedRow key={row.id} to={importPath(row.id)}>
							<ImportRowLabel>
								<StatusPill $tone={statusTone(row.status)}>{statusLabel(row.status)}</StatusPill>
								<span>
									{row.userName} · {sourceSummary(row)} · {countLabel(row.createdEventCount, 'event')}
								</span>
							</ImportRowLabel>
							<RelatedMeta>{formatDateTime(row.createdAt)}</RelatedMeta>
						</RelatedRow>
					))}
				</RelatedList>
			)}
		</Card>
	)
}

export default TripImportsCard
